import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEventHistory } from "../api/events-api";
import { FINANCE_QUERY_KEY, useAddFinanceTransaction } from "../api/finance-api";
import { queryClient } from "../api/queryClient";
import { useLogeMembers } from "../api/user-api";
import { Icon } from "../components/dss/Icon";
import {
  emptyTransactionForm,
  toPayload,
  TransactionForm,
  VaultHeader,
} from "../components/dss/finance/TransactionForm";
import { formatKr } from "../finance/ledger";
import { useSupabaseAuth } from "../supabase/SupabaseContext";

const AddTransaction = () => {
  const navigate = useNavigate();
  const { member: me } = useSupabaseAuth();
  const { data: events = [] } = useEventHistory();
  const { data: members = [] } = useLogeMembers();
  const { mutateAsync: addTransaction, isLoading } = useAddFinanceTransaction();

  const [values, setValues] = useState(emptyTransactionForm);
  const payload = toPayload(values);

  const onSubmit = async () => {
    if (!payload) return;
    await addTransaction({ ...payload, createdBy: me?.id ?? null });
    queryClient.invalidateQueries(FINANCE_QUERY_KEY);
    navigate("/finance");
  };

  const income = values.direction === 1;

  return (
    <div className="mx-auto max-w-md dss-vault text-vault-ink pt-safe h-app flex flex-col overflow-hidden">
      <VaultHeader
        back="Annullér"
        onBack={() => navigate("/finance")}
        title={
          <>
            Ny postering<span className={income ? "text-mint" : "text-ember"}>.</span>
          </>
        }
        sub={me ? `BOGFØRES AF ${me.name.toUpperCase()}` : undefined}
      />

      <div className="px-7 pt-6 flex-1 overflow-y-auto min-h-0 pb-4">
        <TransactionForm
          values={values}
          onChange={setValues}
          events={events}
          members={members}
        />
      </div>

      <div className="px-7 pb-5 pt-3">
        <button
          disabled={!payload || isLoading}
          onClick={onSubmit}
          className={`w-full py-3.5 px-4 rounded-lg font-display text-sm font-bold tracking-wide uppercase flex items-center justify-between gap-3 disabled:opacity-40 ${
            income ? "bg-mint text-vault" : "bg-ember text-vault"
          }`}
        >
          <span className="flex items-center gap-2 min-w-0">
            <Icon name={income ? "arrow-trend-up" : "arrow-trend-down"} size={14} />
            <span className="truncate">Bogfør</span>
          </span>
          <span className="font-mono text-[11px] opacity-75 flex items-center gap-1.5 flex-shrink-0">
            {payload ? formatKr(payload.amountOre, { signed: true, prefix: false }) : "0,00"}
            <Icon name="arrow-right" size={13} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default AddTransaction;
